module.exports = __webpack_public_path__ + "img/mobile-menu.9321e728.svg";